/**
 * Get the width of the vertical window scrollbar if it's visible
 */
export default function getBodyScrollbarWidth() {
  let ownerDocument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  const window = ownerDocument.defaultView;
  return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}